/* What an invitation's link asks the sign-in screen to do (app/admin_routes.py
 * _sign_in_link): go straight to the invitee's directory with their address as
 * `login_hint` (`02`). Null for any link that does not name both, or names a
 * directory this build does not carry, so the screen offers its buttons. */
import type { DirectoryId } from "../auth";

export interface InvitedSignIn {
  directory: DirectoryId;
  loginHint: string;
}

export function invitedSignIn(
  search: string,
  configured: readonly DirectoryId[],
): InvitedSignIn | null {
  const params = new URLSearchParams(search);
  const loginHint = params.get("login_hint")?.trim() ?? "";
  const directory = configured.find((id) => id === params.get("directory"));
  if (!loginHint || !directory) return null;
  return { directory, loginHint };
}
